module.exports = __webpack_public_path__ + "img/pending.83b814b7.svg";